import xPatterns, { commitMask } from "@monsma/XDL/Utilities/xValidate/xPatterns";
import * as Yup from "yup";

type xMasksType = {
    [key: string]: { transform: (newValue: string, oldValue: string, ...options: any) => string; validate?: string };
};

/**
 * define your mask or transformation here
 */
const xMasks: xMasksType = {
    /**
     * phone mask
     */
    phone: {
        /**
         * transform
         * @param {string} newValue
         * @param {string} oldValue
         * @param {...any} params
         * @returns manipulated string
         */
        transform: (newValue, oldValue) => commitMask(newValue, oldValue, xPatterns.phone),

        /**
         * this is a default validation for the mask, can be override if user enter additional validators
         */
        validate: "min:13|max:14",
    },

    /**
     * max transformation
     */
    max: {
        transform: (newValue, oldValue, max) => String(newValue).slice(0, max),
    },

    /**
     * uppercase transformation
     */
    uppercase: {
        transform: (newValue, oldValue) => String(newValue).toUpperCase(),
    },

    /**
     * lowercase transformation
     */
    lowercase: {
        transform: (newValue, oldValue) => String(newValue).toLowerCase(),
    },

    limit: {
        transform: (newValue, oldValue, max) => String(newValue).slice(0, max),
    },
};

/**
 * Define Custom Validator and Mask noEmptySpace
 * @usage noEmptySpace:force
 */
Yup.addMethod<Yup.StringSchema>(Yup.string, "noEmptySpace", function (this: any, options: any, errorMessage: string) {
    return this.test(`test-no-empty-space`, errorMessage, function (this: any, value: string) {
        const { path, createError } = this;

        return (
            /^\S+$/.test(value) ||
            createError({
                path,
                message: errorMessage || "we shouldn't have any white space in this field",
            })
        );
    });
});

// define the mask for noEmptySpace:force
xMasks.noEmptySpace = {
    transform: (newValue, oldValue, options) =>
        options === "force" ? String(newValue).replace(/\s+/gm, "") : newValue,
};

/**
 * Postal Code ( ZIP Code) Validation
 */
Yup.addMethod<Yup.StringSchema>(Yup.string, "postalCode", function (this: any, options: any, errorMessage: string) {
    return this.test(`test-no-empty-space`, errorMessage, function (this: any, value: string) {
        const { path, createError } = this;

        // any additional country regex can be found here
        // https://www.codegrepper.com/code-examples/whatever/validate+postal+code+in+yup
        const regex: { [key: string]: RegExp } = {
            US: /\d{5}([ \-]\d{4})?/gm,
            CA: /[ABCEGHJKLMNPRSTVXY]\d[ABCEGHJ-NPRSTV-Z][ ]?\d[ABCEGHJ-NPRSTV-Z]\d/gm,
        };

        const country = options ?? "US";
        if (!regex[country]) {
            throw new Error(`Country ${country} is not supported validation`);
        }

        return (
            (regex[country] && regex[country].test(value)) ||
            createError({
                path,
                message: errorMessage || "we shouldn't have any white space in this field",
            })
        );
    });
});

// postalCode Mask
xMasks.postalCode = {
    transform: (newValue, oldValue, options) => {
        const country = options ?? "US";
        if (country === "US") {
            return newValue.length > 5
                ? commitMask(newValue, oldValue, xPatterns.longZipCode)
                : commitMask(newValue, oldValue, xPatterns.shortZipCode);
        }
        return newValue;
    },
    validate: "min:5|max:10",
};

export default xMasks;
